import { useContext, useEffect } from 'react'
import ButtonToggle from '../../../../../common/ButtonToggle'
import { ConnectorPinsContext } from '../../context/context'
import { NavContext } from '../../../../../../context/global_context'

const ConnectorToggle = () => {
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const [navState, navDispatch] = useContext(NavContext)

  const CONNECTOR_TYPE = {
    start: 'start',
    end: 'end',
  }

  useEffect(() => {
    if (navState?.destination_only) {
      onSelect('end')
    }
  }, [navState?.destination_only])

  const onSelect = (value) => {
    dispatch({ type: 'dtc_mapping_type', data: value })
  }

  return (
    <ButtonToggle
      className={`flex items-stretch px-16 my-4 ${navState?.destination_only && 'disabled'}`}
      selectedValue={state?.dtc_mapping_type}
      startValue={CONNECTOR_TYPE.start}
      endValue={CONNECTOR_TYPE.end}
      selectStart={() => onSelect('start')}
      selectEnd={() => onSelect('end')}
      startButtonTitle={'Start'}
      endButtonTitle={'End'}
    />
  )
}

export default ConnectorToggle
